// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__3k8GL","cards":"ClientCreditCards_cards__3Yyu4","empty":"ClientCreditCards_empty__1IoFT"};